export interface Response {
  meta: {
    code: string;
  };
  data: any;
}
export const codeExtractor = (domainEventWithNoPayload: Response): any => {
  const code = domainEventWithNoPayload.meta.code;
  console.log({ code });

  return code.split(':').pop();
};
